<template>
    <div class="views-content">

        <!-- Banner -->
        <banner-home :data="data.hero"></banner-home>

        <!-- elements -->
        <div
            v-for="(element, index) in data.elements"
            :key="index"
        >
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>

        <!-- Dev check data -->
        <!--<div class="code">-->
        <!--    <pre>{{data}}</pre>-->
        <!--</div>-->

    </div>
</template>

<script>
    import { BannerHome} from "../components";

    // elements
    import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";

    export default {
        name: "v-home",
        components: {
            BannerHome,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {
                alteredElements: [],
                addedClasses: [] 
            };
        },
        methods: {
            elementClass(elementName, index){
                let classArray = [];

                if(this.addedClasses.length>0){
                    classArray.push(this.addedClasses[index]);
                }

                return classArray;
            },
            addNeighbourClassHandle(payload) {
                this.addedClasses[payload.refIndex+payload.offset].push(payload.class);
            }
        },
        created() {
            this.data.elements.forEach( (element, index) => {
                this.alteredElements.push(element);
                this.addedClasses.push([]);

                this.alteredElements[index].refIndex = index;
            } );
        },
        mounted() {
            
        }
    };
</script>
